import { Field } from "formik";
import MultiSelect from "components/select/multi/MultiSelect";
import { Select } from "components";
import { useFormInputHelpers } from "./useFormInputHelpers";

const FormSelectInput = ({
  name,
  onChange,
  sx,
  shouldHaveErrorBehaviorAfterSubmit,
  helperText,
  isMultiple,
  className,
  ...props
}) => {
  const { shouldDisplayError, finalHelperText } = useFormInputHelpers({
    name,
    shouldHaveErrorBehaviorAfterSubmit,
    helperText,
  });

  if (isMultiple) {
    return (
      <Field
        name={name}
        as={MultiSelect}
        helperText={finalHelperText}
        isError={shouldDisplayError}
        {...(typeof onChange === "function" ? { onChange } : {})}
        sx={sx}
        className={className}
        {...props}
      />
    );
  }
  return (
    <Field
      name={name}
      as={Select}
      helperText={finalHelperText}
      isError={shouldDisplayError}
      {...(typeof onChange === "function" ? { onChange } : {})}
      sx={sx}
      className={className}
      {...props}
    />
  );
};

export default FormSelectInput;
